import React from 'react';
import { motion } from 'framer-motion';
import styles from './QuickCaptureButton.module.css';

interface QuickCaptureButtonProps {
  onClick: () => void;
}

export function QuickCaptureButton({ onClick }: QuickCaptureButtonProps) {
  return (
    <motion.button
      className={styles.quickCapture}
      onClick={onClick}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      aria-label="Quick capture (Command+K)"
    >
      <span className={styles.icon} aria-hidden="true">
        ✏️
      </span>
      <span className={styles.shortcutHint} aria-hidden="true">
        ⌘K
      </span>
    </motion.button>
  );
}

export default QuickCaptureButton;
